import store from "./store";

const getUserName = () => {
  const state = store.getState();
  return state?.auth?.authData?.full_name;
};

export default getUserName;
